import {faBell} from '@fortawesome/free-solid-svg-icons/faBell';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {Popover, Transition} from '@headlessui/react';
import clsx from 'clsx';
import moment from 'moment';
import {Fragment, useEffect, useState} from 'react';
import {useAuth} from '../../../../modules/auth';
import {abbreviate} from '../../../helpers';
import useNotifications from '../../../hooks/useNotifications';
import {useI18n} from '../../../providers/I18nProvider';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import {ReactComponent as Logo} from '../../../../../assets/images/logo.svg';
import useNotifyReadAll from '../../../hooks/useNotifyReadAll';

const Notifications = () => {
	const [isNotify, setNotify] = useState(false);
	const [count, setCount] = useState<number>(0);
	const {data} = useNotifications({initialItemPerPage: 5});
	const {readAll} = useNotifyReadAll();
	const navigate = useNavigate();
	const location = useLocation();

	const {currentUser} = useAuth();
	const {i18n} = useI18n();
	const {width} = useWindowDimensions();

	useEffect(() => {
		if (data?.data) {
			const unreadCount = data?.stats.unread_count as number;
			setCount(unreadCount);
			if ((data?.stats.unread_count as number) > 0) setNotify(true);
			else setNotify(false);
		}
	}, [data]);
	const shouldHide = location.pathname === '/campaign/create' && width < 768;
	if (shouldHide || !currentUser) return null;

	const onNotificationClick = async () => {
		navigate('/dashboard/notifications');
		await readAll();
		setCount(0);
	};

	return (
		<Popover className='relative mt-1 '>
			{({open, close}) => (
				<>
					<Popover.Button
						className={clsx('group inline-flex items-center relative border-none outline-none', {
							'text-opacity-90': open,
						})}
					>
						<FontAwesomeIcon
							className='text-primary h-[22px] w-[20px]'
							size={width < 820 ? 'sm' : 'lg'}
							icon={faBell}
						/>
						{isNotify ? (
							<span
								className='absolute bottom-2 left-3  bg-red-500 text-white text-xs rounded-full px-1 py-0.5'
								style={{fontSize: '11px'}}
							>
								{count > 9 ? '9+' : count}
							</span>
						) : (
							''
						)}
					</Popover.Button>
					<Transition
						as={Fragment}
						enter='transition ease-out duration-200'
						enterFrom='opacity-0 translate-y-1'
						enterTo='opacity-100 translate-y-0'
						leave='transition ease-in duration-150'
						leaveFrom='opacity-100 translate-y-0'
						leaveTo='opacity-0 translate-y-1'
					>
						<Popover.Panel className='absolute left-1/2 z-10 mt-3 w-screen max-w-[22rem] -translate-x-[90%] transform px-4 sm:px-0 lg:max-w-md '>
							<div className='overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white'>
								<div className='flex justify-between mb-[16px] mt-2'>
									<p className='text-[16px] ml-[7px] font-bold mt-[2px]'>{i18n('NOTIFICATION.NAME')}</p>
									<Link
										// className='text-queen-blue text-[14px] sm:text-[16px] md:text-[20px] font-bold'
										to='/dashboard/notifications'
										onClick={() => {
											onNotificationClick();
											close();
										}}
									>
										<button className='btn py-2 px-4 bg-gray-200 text-gray-700 rounded mr-[10px] font-medium text-[16px]'>
											{/* View All */}
											{i18n('DASHBOARD.NOTIFICATION.BUTTON.ALL')}
										</button>
									</Link>
								</div>
								{data?.data?.length ? (
									data.data.map((notification) => (
										<Link
											onClick={() => {
												onNotificationClick();
												close();
											}}
											key={notification.id}
											to='/dashboard/notifications'
											className='block px-4 py-2 hover:bg-gray-100 transition-colors'
											style={notification.read_at !== null ? {} : {backgroundColor: '#F1EFEF'}}
											// onClick={() => {
											// 	onNotificationClick(notification.id);
											// 	navigate()
											// }}
										>
											<div className='flex items-center pb-3'>
												<Logo />

												<div>
													<div className='font-semibold text-sm text-gray-800 truncate'>
														{abbreviate(notification.title)}
													</div>
													<div className='text-xs text-gray-500'>
														{moment(notification.created_at).format('h:mm a, DD MMMM, YYYY')}
													</div>
												</div>
											</div>
										</Link>
									))
								) : (
									<div className='px-4 py-6 text-center text-gray-600'> {i18n('LAYOUT.HEADER.NOTIFICATION.EMPTY')}</div>
								)}
							</div>
						</Popover.Panel>
					</Transition>
				</>
			)}
		</Popover>
	);
};

export default Notifications;

// <Popover className='relative mt-1'>
// 	{({open}) => (
// 		<>
// 			<Popover.Button
// 				className={clsx('group inline-flex items-center', {
// 					'text-opacity-90': open,
// 				})}
// 			>
// 				<FontAwesomeIcon
// 					className='text-primary h-[22px] w-[20px]'
// 					size={width < 820 ? 'sm' : 'lg'}
// 					icon={faBell}
// 				/>
// 				{isNotify ? (
// 					<span
// 						style={{
// 							color: 'white',
// 							borderRadius: '50%',
// 							background: 'red',
// 							padding: '1px',
// 							height: '17px',
// 							width: '19px',
// 							position: 'absolute',
// 							top: '3px',
// 							right: '-2px',
// 							fontSize: '11px',
// 						}}
// 					>
// 						{count > 9 ? <span>9+</span> : <span>{count}</span>}
// 					</span>
// 				) : (
// 					''
// 				)}
// 			</Popover.Button>
// 			<Transition
// 				as={Fragment}
// 				enter='transition ease-out duration-200'
// 				enterFrom='opacity-0 translate-y-1'
// 				enterTo='opacity-100 translate-y-0'
// 				leave='transition ease-in duration-150'
// 				leaveFrom='opacity-100 translate-y-0'
// 				leaveTo='opacity-0 translate-y-1'
// 			>
// 				<Popover.Panel className='absolute left-1/2 z-10 mt-3 w-screen max-w-sm -translate-x-1/2 transform px-4 sm:px-0 lg:max-w-3xl'>
// 					<div className='overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5'>
// 						<div className='relative grid gap-8 bg-white p-7 lg:grid-cols-2'>
// 							{data &&
// 								data.data.map((notification) => (
// 									<div key={notification.id} className='menu-item px-3 my-0'>
// 										<Link
// 											to={routes.dashboard}
// 											className='menu-link px-3 py-2'
// 											style={notification.read_at !== null ? {} : {backgroundColor: '#F1EFEF'}}
// 											onClick={() => {
// 												onNotificationClick(notification.id);
// 											}}
// 										>
// 											<div className='d-flex align-items-center'>
// 												<div className='rounded w-25px h-25px' style={{backgroundColor: '#ECF8FF'}} />
// 												<div className='ms-4'>
// 													<div className='fw-bold fs-6 mb-2' style={{color: '#3F4254'}}>
// 														{abbreviate(notification.title)}
// 													</div>
// 													<div className='fw-semibold fs-7' style={{color: '#B5B5C3'}}>
// 														{moment(notification.created_at).format('h:mm a, DD MMMM, YYYY')}
// 													</div>
// 												</div>
// 											</div>
// 										</Link>
// 									</div>
// 								))}

// 							{(!data || data.data.length === 0) && (
// 								<div className='menu-item px-3 my-0 text-center mt-5'>
// 									{i18n('LAYOUT.HEADER.NOTIFICATION.EMPTY')}
// 								</div>
// 							)}
// 						</div>
// 					</div>
// 				</Popover.Panel>
// 			</Transition>
// 		</>
// 	)}
// </Popover>
